import { logout } from "./auth";

/**
 * Confirms that auth-service cleared every ambient HttpOnly authentication and
 * SSO-state cookie before an anonymous account-deletion request is attempted.
 */
export const requireAccountDeletionAnonymousSession = async (dispatch) => {
    if (typeof dispatch !== "function") {
        throw new TypeError("Redux dispatch is required");
    }
    const result = await dispatch(logout());
    if (result?.serverLogoutSucceeded !== true) {
        throw new Error("Auth-service did not confirm anonymous-session preparation");
    }
};
